class BlogPosts extends HTMLElement {
  constructor() {
    super();
    this.initializeTagFiltering();
  }

  initializeTagFiltering() {
    const tagLinks = document.querySelectorAll('.blog-page_tags a');
    const blogPostsContainer = this.closest('[id^="blog-posts-"]');

    if (!blogPostsContainer) {
      console.error('Blog posts container not found');
      return;
    }

    tagLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        this.filterByTag(link.href, link, tagLinks, blogPostsContainer);
      });
    });
  }

  async filterByTag(url, clickedLink, allLinks, container) {
    // Update selected state on tags
    allLinks.forEach(link => link.classList.remove('tag--selected'));
    clickedLink.classList.add('tag--selected');

    // Add loading state
    this.style.opacity = '0.5';
    this.style.pointerEvents = 'none';

    try {
      // Fetch the filtered page
      const response = await fetch(url);
      const html = await response.text();
      
      // Parse the response
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Find the blog-posts element in the response (not the wrapper div)
      const newBlogPosts = doc.querySelector('blog-posts');
      
      if (newBlogPosts) {
        // Replace the content of this blog-posts element
        this.innerHTML = newBlogPosts.innerHTML;
        
        // Update URL without reload
        window.history.pushState({}, '', url);
      }
    } catch (error) {
      console.error('Error filtering blog posts:', error);
      // Fallback to regular navigation on error
      window.location.href = url;
    } finally {
      // Remove loading state
      this.style.opacity = '1';
      this.style.pointerEvents = 'auto';
    }
  }
}

customElements.define('blog-posts', BlogPosts);